import { useEffect, useState } from 'react';

import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { customInstanceApis } from '../../../apis/customInstanceApis';
import Loading from '../../../components/elements/loading/Loading';
import Title from '../../../components/elements/title/Title';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import List from '../../../components/sections/list/List';

const ProjectCustInstListPage = () => {
  const { projectId } = useParams();
  const { t } = useTranslation();

  const [customInstList, setCustomInstList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: modelRes } =
        await customInstanceApis.getCustomInstances(projectId);
      setCustomInstList(modelRes.content);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      {loading && <Loading style={{ marginTop: '1em' }} />}
      {error && (
        <Alert style={{ marginTop: '1em' }} severity="error">
          {t('fetchCustomInstError', { ns: 'notifications' })}
        </Alert>
      )}
      {!loading && customInstList && !error && (
        <section>
          <Breadcrumbs />
          <Title text={t('customInst', { ns: 'titles' })} />
          <List data={customInstList} />
        </section>
      )}
    </Container>
  );
};

export default ProjectCustInstListPage;
